import { Button, Input, Typography } from "antd";
import {
  GoogleMap,
  Marker,
  DirectionsRenderer,
  Autocomplete,
} from "@react-google-maps/api";
import { useRef, useState, useEffect } from "react";
import { FcLike } from "react-icons/fc";
import { saveAs } from "file-saver";
// import { DOMParser, XMLSerializer } from 'xmldom';
// import GPXBuilder from "gpx-builder";
import { alertMessage } from "../common/utils/constants";

const { Text } = Typography;

const center = { lat: 43.7879052, lng: -91.2269384 };

function Maps(props) {
  const {
    roundTrip,
    originAddress,
    destinationAddress,
    breakAddress
  } = props;
  const [map, setMap] = useState(null);
  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [distance, setDistance] = useState("");
  const [duration, setDuration] = useState("");
  const [originValue, setOriginValue] = useState("");
  const [destinationValue, setDestinationValue] = useState("");
  const originRef = useRef(null);
  const destinationRef = useRef(null);
  const [breakLocations, setBreakLocations] = useState([]);
  const [breakAutocomplete, setBreakAutocomplete] = useState([]);
  const [gpxData, setGpxData] = useState(null);




useEffect(() => {
  if (originAddress) {
    setOriginValue(originAddress);
  }
}, [originAddress])

useEffect(() => {
  if (destinationAddress) {
    setDestinationValue(destinationAddress);
  }
}, [destinationAddress])

useEffect(() => {
  if (breakAddress) {
    setBreakLocations(breakAddress);
  }
}, [breakAddress])

  function generateGPX() {
    if (!directionsResponse) {
      return;
    }

    const gpxData = `
      <?xml version="1.0"?>
      <gpx version="1.1" xmlns="http:// www.topografix.com/GPX/1/1">
       <trk>
         <name>Route</name>
         <trkseg>
           ${directionsResponse.routes[0].legs
             .flatMap((leg) =>
               leg.steps.map(
                 (step) => `
                 <trkpt lat="${step.start_location.lat()}" lon="${step.start_location.lng()}"></trkpt>
            `
               )
             )
             .join("\n")}
         </trkseg>
       </trk>
      </gpx>
      `;
    setGpxData(gpxData);
  }

  // ...

  function downloadGPX() {
    const blob = new Blob([gpxData], {
      type: "application/gpx+xml;charset=utf-8",
    });
    saveAs(blob, "route.gpx");
  }

  function removeBreakLocation(index) {
    const updatedLocations = [...breakLocations];
    updatedLocations.splice(index, 1);
    setBreakLocations(updatedLocations);
    const updatedAutocomplete = [...breakAutocomplete];
    updatedAutocomplete.splice(index, 1);
    setBreakAutocomplete(updatedAutocomplete);
  }

  function handleBreakLocationSelect(index) {
    if (breakAutocomplete[index] !== null) {
      const place = breakAutocomplete[index].getPlace();
      const updatedLocations = [...breakLocations];
      updatedLocations[index] = place.formatted_address;
      setBreakLocations(updatedLocations);
    }
  }

  function addBreakLocation() {
    setBreakLocations([...breakLocations, ""]);
  }

  async function calculateRoute() {
    try {
      if (!originValue || !destinationValue) {
        return;
      }

      const waypoints = breakLocations.map((location) => ({ location }));

      const directionsService = new window.google.maps.DirectionsService();
      // console.log(originValue );
      // console.log(destinationValue);
      // console.log(waypoints );
      const results = await directionsService.route({
        origin: originValue,
        destination: destinationValue,
        waypoints: waypoints,
        travelMode: window.google.maps.TravelMode.DRIVING,
      });

      setDirectionsResponse(results);
      let totalDistance = 0;
      let totalDuration = 0;

      results.routes[0].legs.forEach((leg) => {
        totalDistance += parseInt(leg.distance.text.replace(/,/g, ""));
        totalDuration += leg.duration.text;
      });
      setDistance(totalDistance);
      setDuration(totalDuration);
      generateGPX();
    } catch {
      alertMessage("error", "error", "Route Not Possible", "bottomRight");
    }
  }

  function clearRoute() {
    setDirectionsResponse(null);
    setDistance("");
    setDuration("");
    setOriginValue("");
    setDestinationValue("");
    setBreakLocations([]);
  }

  function handleOriginSelect(value) {
    if (originRef.current !== null) {
      const place = originRef.current.input.value;
      setOriginValue(place);
    } else {
      setOriginValue(value);
    }
  }

  function handleDestinationSelect(value) {
    if (destinationRef.current !== null) {
      const place = destinationRef.current.input.value;
      setDestinationValue(place);
    } else {
      setDestinationValue(value);
    }
  }

  return (
    <div style={{ position: "relative", height: "100vh", width: "100%" }}>
      <div
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          height: "100%",
          width: "100%",
        }}
      >
        <GoogleMap
          center={center}
          zoom={15}
          mapContainerStyle={{ width: "100%", height: "100%" }}
          options={{
            zoomControl: false,
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
          }}
          onLoad={(map) => setMap(map)}
        >
          <Marker position={center} />
          {directionsResponse && (
            <DirectionsRenderer directions={directionsResponse} />
          )}
        </GoogleMap>
      </div>

      <div
        style={{
          padding: 16,
          borderRadius: 8,
          margin: 16,
          backgroundColor: "white",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 8,
          }}
        >
          {/* originRef.current = autocomplete */}
          <Autocomplete
            value={originValue}
            onLoad={(autocomplete) => (originRef.current = autocomplete)}
            onPlaceChanged={handleOriginSelect}
          >
            <Input
              placeholder="Origin"
              ref={originRef}
              value={originValue}
              onChange={(e) => setOriginValue(e.target.value)}
            />
          </Autocomplete>
          <Autocomplete
            value={destinationValue}
            onLoad={(autocomplete) => (destinationRef.current = autocomplete)}
            onPlaceChanged={handleDestinationSelect}
          >
            <Input
              placeholder="Destination"
              ref={destinationRef}
              value={destinationValue}
              onChange={(e) => setDestinationValue(e.target.value)}
            />
          </Autocomplete>
          <Button.Group>
            <Button type="primary" onClick={calculateRoute}>
              Calculate Route
            </Button>
            <Button type="primary" danger onClick={clearRoute}>
              Clear Route
            </Button>
          </Button.Group>
        </div>
        <div style={{ marginBottom: 8, display: "flex" }}>
          {breakLocations.map((location, index) => (
            <>
              <Autocomplete
                key={index}
                value={location}
                onLoad={(autocomplete) => {
                  const updatedAutocomplete = [...breakAutocomplete];
                  updatedAutocomplete[index] = autocomplete;
                  setBreakAutocomplete(updatedAutocomplete);
                }}
                onPlaceChanged={() => handleBreakLocationSelect(index)}
              >
                <Input
                  placeholder={`Break Location ${index + 1}`}
                  value={location}
                  onChange={(e) => {
                    const updatedLocations = [...breakLocations];
                    updatedLocations[index] = e.target.value;
                    setBreakLocations(updatedLocations);
                  }}
                />
              </Autocomplete>
              <Button
                type="dashed"
                danger
                onClick={() => removeBreakLocation(index)}
              >
                Remove
              </Button>
            </>
          ))}
          <Button type="dashed" onClick={addBreakLocation}>
            Add Break Location
          </Button>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "400px",
            position: "relative",
          }}
        >
          {/* {distance && duration && (
            <div
              style={{
                display: "flex",
                position: "relative",
                width: "400px",
                marginTop: "50px",
              }}
            >
              <Text
                style={{
                  position: "relative",
                  backgroundColor: "yellow",
                }}
              >
                Distance: {distance},
              </Text>
              <br />
              <Text
                style={{
                  position: "relative",
                  backgroundColor: "yellow",
                }}
              >
                {" "}
                Duration: {duration}
              </Text>
            </div>
          )} */}
          <div style={{ display: "flex", position: "absolute" }}>
            <Button
              icon={<FcLike />}
              shape="circle"
              onClick={() => {
                map.panTo(center);
                map.setZoom(15);
              }}
            />

            {/* {gpxData && (
              <Button
                type="primary"
                onClick={downloadGPX}
                style={{ marginLeft: "16px" }}
              >
                Download GPX
              </Button>
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Maps;
